import VisualizarVendaModal from './VisualizarVendaModal';

export default VisualizarVendaModal;
